export default __webpack_public_path__ + "static/media/vid.0c29d677.png";